<template>
	<div>
		<div class="flex xs-12 xs-between">
			<label class="fs3 c6 fw6 mb1">{{ label }}</label>
			<div v-if="value" class="fs3 cu2 cError" @click="handleReset">
				{{ $t("clear") }}
			</div>
		</div>
		<j-base-input-text
			:value="value"
			:size="size"
			@input="$emit('input', $event)"
		/>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText/"

export default {
	components: { JBaseInputText },
	props: ["value", "size", "label"],

	data() {
		return {}
	},

	methods: {
		handleReset() {
			this.$emit("input", null)
		}
	}
}
</script>
